export default "__VITE_ASSET__CL0rr2Cc__"